import { useCallback } from 'react';
import { StyleSheet, Platform } from 'react-native';
import { useBoolean } from 'usehooks-ts';

import { IconButton } from '../IconButton';
import { OverflowMenu, MenuItem, MenuItemProps } from '../OverflowMenu';

import { MoreVerticalIcon } from '../../assets/icons';

type PressHandlerType = () => unknown;

export const ActionsMenu = ({ actions }: Props) => {
	const { value: isOpen, setFalse: close, setTrue: open } = useBoolean();

	const renderAnchor = useCallback(
		() => (
			<IconButton
				style={styles.menuButton}
				onPress={open}
				Icon={MoreVerticalIcon}
				appearance="ghost"
				// @ts-expect-error valid for web
				dataSet={{
					includeTransformsInMeasurments: true,
				}}
			/>
		),
		[open],
	);

	const handleOptionPress = useCallback(
		(onPressAction: PressHandlerType) => () => {
			close();
			onPressAction?.();
		},
		[close],
	);

	const visibleActions = actions.filter(({ hidden }) => !hidden);
	if (visibleActions.length === 0) {
		return null;
	}

	return (
		<OverflowMenu
			visible={isOpen}
			onBackdropPress={close}
			anchor={renderAnchor}
			placement="bottom end"
			style={styles.menu}
		>
			{visibleActions.map(({ onPress, ...menuItemProps }, index) => (
				<MenuItem key={index} {...menuItemProps} onPress={handleOptionPress(onPress)} />
			))}
		</OverflowMenu>
	);
};

type Props = {
	actions: ({ onPress: PressHandlerType; hidden?: boolean } & Omit<MenuItemProps, 'onPress'>)[];
};

const styles = StyleSheet.create({
	menuButton: {
		...Platform.select({
			web: {
				marginVertical: 'auto',
			},
			default: {
				height: '100%',
			},
		}),
	},
	menu: {
		width: 'auto',
	},
});
